import { render, staticRenderFns } from "./Detections.vue?vue&type=template&id=3b96c83d&scoped=true&"
import script from "./Detections.vue?vue&type=script&lang=js&"
export * from "./Detections.vue?vue&type=script&lang=js&"
import style0 from "./Detections.vue?vue&type=style&index=0&id=3b96c83d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96c83d",
  null
  
)

export default component.exports